import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/DragHandle';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Avatar from '@mui/material/Avatar';

import { getLoggedIn, getMe } from 'redux/account/selectors';
import { getItemCategory } from 'redux/lov/selectors';
import { userInitials, userDisplayName } from 'components/utilities';

const AppDrawer: React.FC = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector(getLoggedIn);
  const me = useSelector(getMe);
  const itemCategory = useSelector(getItemCategory);

  // Drawer
  const [open, setOpen] = useState(false);
  const [swapTimeOpen, setSwapTimeOpen] = useState(true);

  const toggle =
    (isOpened: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      setOpen(isOpened);
    };

  const toggleSwapTime =
    (isOpened: boolean) => (_event: React.KeyboardEvent | React.MouseEvent) => {
      setSwapTimeOpen(isOpened);
    };

  const goTo = (route: string) => {
    return (_e: React.FormEvent) => {
      navigate(route);
      setOpen(false);
    };
  };

  return (
    <div>
      <IconButton
        size="large"
        aria-label="app drawer"
        aria-controls="menu-appdrawer"
        onClick={toggle(true)}
        color="inherit"
      >
        <MenuIcon />
      </IconButton>
      <Drawer anchor="right" open={open} onClose={toggle(false)}>
        <List
          sx={{
            width: '100%',
            minWidth: 250,
            maxWidth: 320,
            bgcolor: 'background.paper',
          }}
          component="nav"
        >
          {isLoggedIn && me && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
              <Avatar>{userInitials(me)}</Avatar>
            </Box>
          )}
          {/* Login */}
          {!isLoggedIn && (
            <ListItemButton onClick={goTo('/login')}>
              <ListItemText primary="Login" />
            </ListItemButton>
          )}
          {/* Me */}
          {isLoggedIn && me && (
            <ListItemButton onClick={goTo('/me')}>
              <ListItemText primary={userDisplayName(me)} />
            </ListItemButton>
          )}
          <ListItemButton onClick={goTo('/')}>
            <ListItemText primary="Home" />
          </ListItemButton>
          <ListItemButton onClick={toggleSwapTime(!swapTimeOpen)}>
            <ListItemText primary="Swap Time" />
            {itemCategory?.length > 0 && (
              <>{swapTimeOpen ? <ExpandLess /> : <ExpandMore />}</>
            )}
          </ListItemButton>
          <Collapse in={swapTimeOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {itemCategory.map((it) => (
                <ListItemButton
                  key={it.code}
                  sx={{ pl: 4 }}
                  onClick={goTo('/swap?category=' + it.code)}
                >
                  <ListItemText secondary={it.description} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
        </List>
      </Drawer>
    </div>
  );
};

export default AppDrawer;
